import React from "react";

export  function ZaviramedCinematicHero() {
  return (
    <section className="zv3-wrap">
      <div className="zv3-bg-glow zv3-bg-glow-a" />
      <div className="zv3-bg-glow zv3-bg-glow-b" />
      <div className="zv3-bg-glow zv3-bg-glow-c" />
      <div className="zv3-bg-grid" />

      <div className="zv3-layout">
        {/* LEFT COPY */}
        <div className="zv3-copy">
          <div className="zv3-tag">
            <span className="zv3-tag-dot" />
            WhatsApp-first telemedicine
          </div>

          <h1 className="zv3-title">
            Search gives answers.
            <span>Zaviramed gives care.</span>
          </h1>

          <p className="zv3-sub">
            Skip the panic-scroll. Start a WhatsApp consultation, share your
            symptoms, and get guided by a real doctor on Zaviramed.
          </p>

          <div className="zv3-metrics">
            <div className="zv3-metric-card">
              <div className="zv3-metric-label">WhatsApp Number</div>
              <div className="zv3-metric-value">0806 980 4062</div>
            </div>

            <div className="zv3-metric-card">
              <div className="zv3-metric-label">Experience</div>
              <div className="zv3-metric-value">Real doctors. Real care.</div>
            </div>
          </div>
        </div>

        {/* DEVICE */}
       <PhoneScreen/>
      </div>

      <style>{styles}</style>
    </section>
  );
}


export function PhoneScreen() {
    return(
        <div className="zv3-device-stage">
        <style>{styles}</style>
        <div className="zv3-device-shadow" />

        <div className="zv3-phone">
          <div className="zv3-phone-glow" />
          <div className="zv3-phone-frame">
            <div className="zv3-notch" />
            <div className="zv3-screen">
              {/* STATUS BAR */}
              <div className="zv3-status-bar">
                <span className="zv3-time">9:41</span>
                <div className="zv3-status-right">
                  <span className="zv3-signal" />
                  <span className="zv3-wifi" />
                  <span className="zv3-battery">
                    <span className="zv3-battery-level" />
                  </span>
                </div>
              </div>

              {/* SCENES */}
              <SceneGoogleSearch />
              <SceneGoogleResults />
              <SceneZaviramedContact logo="/logo_new_nobg.png" />
              <SceneWhatsappChat logo="/logo_new_nobg.png" />
              <SceneFinal logo="/logo_new_nobg.png" />
            </div>
          </div>
        </div>
      </div>
    )
}

function SceneGoogleSearch() {
  return (
    <div className="zv3-scene zv3-scene-search">
      <div className="zv3-google-logo">
        <span className="g-deep">G</span>
        <span className="g-leaf">o</span>
        <span className="g-bright">o</span>
        <span className="g-deep">g</span>
        <span className="g-fresh">l</span>
        <span className="g-leaf">e</span>
      </div>

      <div className="zv3-search-bar">
        <svg className="zv3-search-icon" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M16.5 16.5L21 21" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>

        <div className="zv3-search-text-wrap">
          <span className="zv3-search-text">i have a fever what do i do</span>
          <span className="zv3-search-cursor" />
        </div>

        <div className="zv3-search-actions">
          <span className="zv3-mic-dot" />
        </div>
      </div>

      <div className="zv3-search-helper">
        Search for symptoms, doctors, and care guidance
      </div>
    </div>
  );
}

function SceneGoogleResults() {
  return (
    <div className="zv3-scene zv3-scene-results">
      <div className="zv3-results-top">
        <div className="zv3-results-search">
          <span className="zv3-results-query">i have a fever what do i do</span>
        </div>
      </div>

      <div className="zv3-results-tabs">
        <span className="active">All</span>
        <span>Images</span>
        <span>News</span>
        <span>Videos</span>
      </div>

      <ResultCard
        className="r1"
        source="Health guide"
        title="Fever: causes, home remedies, and when to seek urgent care"
        text="Drink fluids, rest well, check your temperature, and watch for red-flag symptoms..."
      />

      <ResultCard
        className="r2"
        source="Forum discussion"
        title="People share different fever treatments"
        text="Many opinions appear online, but not every answer applies safely to your own condition..."
      />

      <ResultCard
        className="r3 warning"
        source="Too many answers"
        title="Search can confuse when symptoms feel serious"
        text="Instead of guessing, speak with a qualified medical professional for clear next steps."
      />
    </div>
  );
}

function ResultCard({ source, title, text, className = "" }) {
  return (
    <div className={`zv3-result-card ${className}`}>
      <small>{source}</small>
      <h4>{title}</h4>
      <p>{text}</p>
    </div>
  );
}

function SceneZaviramedContact({ logo }) {
  return (
    <div className="zv3-scene zv3-scene-contact">
      <div className="zv3-contact-hero">
        <div className="zv3-contact-logo-wrap">
          <img src={logo} alt="Zaviramed logo" className="zv3-contact-logo" />
        </div>

        <div className="zv3-contact-brand">Zaviramed</div>
        <div className="zv3-contact-desc">Chat with real doctors on WhatsApp</div>
      </div>

      <div className="zv3-contact-number-card">
        <div className="zv3-contact-number-label">WhatsApp Number</div>
        <div className="zv3-contact-number">0806 980 4062</div>
        <div className="zv3-contact-number-sub">
          Fast access to medical guidance from real doctors
        </div>
      </div>

      <div className="zv3-contact-pills">
        <span>Fever</span>
        <span>Headache</span>
        <span>Weakness</span>
        <span>Prescription support</span>
      </div>
    </div>
  );
}

function SceneWhatsappChat({ logo }) {
  return (
    <div className="zv3-scene zv3-scene-whatsapp">
      <div className="zv3-wa-wallpaper" />

      <div className="zv3-wa-header">
        <div className="zv3-wa-header-left">
          <span className="zv3-wa-back">‹</span>
          <div className="zv3-wa-avatar">
            <img src={logo} alt="Zaviramed" />
          </div>
          <div className="zv3-wa-profile">
            <strong>Zaviramed</strong>
            <span>online</span>
          </div>
        </div>

        <div className="zv3-wa-header-right">
          <span className="zv3-wa-header-icon">⌕</span>
          <span className="zv3-wa-header-icon">⋮</span>
        </div>
      </div>

      <div className="zv3-wa-date-chip">Today</div>

      <div className="zv3-wa-messages">
        <ChatBubble
          side="right"
          className="m1"
          text="Hello doctor, I have fever and headache. What should I do?"
          time="9:42"
        />

        <TypingBubble className="t1" />

        <ChatBubble
          side="left"
          className="m2"
          text="Hello 👋 I’m a Zaviramed doctor. How long have you had the fever?"
          time="9:43"
        />

        <ChatBubble
          side="right"
          className="m3"
          text="About 2 days. I also feel weak and my body hurts."
          time="9:44"
        />

        <TypingBubble className="t2" />

        <ChatBubble
          side="left"
          className="m4"
          text="Thank you. Any chest pain, difficulty breathing, confusion, convulsion, or persistent vomiting?"
          time="9:45"
        />

        <ChatBubble side="right" className="m5" text="No, none of those." time="9:46" />

        <ChatBubble
          side="left"
          className="m6"
          text="Okay. Keep taking fluids, rest, and monitor your temperature. I’ll guide you on safe next steps."
          time="9:47"
        />
      </div>

      <div className="zv3-wa-compose">
        <div className="zv3-wa-compose-left">＋</div>
        <div className="zv3-wa-input">Message</div>
        <div className="zv3-wa-send">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 20L21 12L3 4V10L15 12L3 14V20Z" fill="currentColor" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function ChatBubble({ side, text, time, className = "" }) {
  return (
    <div className={`zv3-wa-row ${side} ${className}`}>
      <div className="zv3-wa-bubble">
        <span>{text}</span>
        <small>{time}</small>
      </div>
    </div>
  );
}

function TypingBubble({ className = "" }) {
  return (
    <div className={`zv3-wa-row left ${className}`}>
      <div className="zv3-wa-bubble zv3-wa-typing">
        <i />
        <i />
        <i />
      </div>
    </div>
  );
}

function SceneFinal({ logo }) {
  return (
    <div className="zv3-scene zv3-scene-final">
      <div className="zv3-final-rings">
        <span />
        <span />
        <span />
      </div>

      <div className="zv3-final-logo-wrap">
        <img src={logo} alt="Zaviramed logo" className="zv3-final-logo" />
      </div>

      <h2 className="zv3-final-title">
        Trust the best.
        <span>Trust Zaviramed.</span>
      </h2>

      <p className="zv3-final-sub">Real doctors. Real guidance. Fast care on WhatsApp.</p>

      <div className="zv3-final-number">0806 980 4062</div>
    </div>
  );
}

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800;9..40,900;9..40,1000&family=Instrument+Serif:ital@0;1&family=Sora:wght@400;500;600;700;800&display=swap');

  :root {
    --zv3-display: 'Sora', 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --zv3-body: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --zv3-serif: 'Instrument Serif', Georgia, serif;
    --zv3-google: Arial, Helvetica, sans-serif;
    --zv3-whatsapp: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'DM Sans', Roboto, Arial, sans-serif;
    --zv3-green: #25D366;
    --zv3-green-2: #25D366;
    --zv3-teal: #075E54;
    --zv3-teal-2: #118a4f;
    --zv3-ink: #0f172a;
    --zv3-soft-ink: #475569;
    --zv3-muted: #64748b;
    --zv3-card: rgba(255,255,255,0.78);
    --zv3-border: rgba(15,23,42,0.08);
    --zv3-duration: 24s;
    --zv3-shadow: 0 24px 80px rgba(15,23,42,0.14);
  }

  * {
    box-sizing: border-box;
  }

  .zv3-wrap,
  .zv3-wrap * {
    font-family: var(--zv3-body);
    -webkit-font-smoothing: antialiased;
    text-rendering: geometricPrecision;
  }

  .zv3-wrap {
    position: relative;
    overflow: hidden;
    min-height: 100svh;
    width: 100%;
    padding: clamp(16px, 3vw, 42px);
    background:
      radial-gradient(circle at 8% 12%, rgba(34,197,94,0.17), transparent 24%),
      radial-gradient(circle at 88% 8%, rgba(7,94,84,0.1), transparent 26%),
      radial-gradient(circle at 75% 84%, rgba(20,184,166,0.15), transparent 24%),
      linear-gradient(135deg, #f8fffb 0%, #f4fff8 35%, #f8fafc 100%);
    isolation: isolate;
  }

  .zv3-bg-glow {
    position: absolute;
    border-radius: 999px;
    filter: blur(18px);
    z-index: -2;
    opacity: .9;
    animation: zv3AmbientFloat 12s ease-in-out infinite;
  }

  .zv3-bg-glow-a {
    width: 240px;
    height: 240px;
    left: -40px;
    top: 120px;
    background: rgba(187,247,208,.72);
  }

  .zv3-bg-glow-b {
    width: 320px;
    height: 320px;
    right: -80px;
    top: 80px;
    background: rgba(209,250,229,.72);
    animation-delay: -3s;
  }

  .zv3-bg-glow-c {
    width: 260px;
    height: 260px;
    right: 18%;
    bottom: -60px;
    background: rgba(187,247,208,.72);
    animation-delay: -6s;
  }

  .zv3-bg-grid {
    position: absolute;
    inset: 0;
    z-index: -3;
    background-image: radial-gradient(rgba(15,118,110,.12) 1px, transparent 1px);
    background-size: 24px 24px;
    mask-image: linear-gradient(to bottom, transparent, black 16%, black 84%, transparent);
    opacity: .8;
  }

  .zv3-layout {
    width: min(1120px, 100%);
    min-height: calc(100svh - clamp(32px, 6vw, 84px));
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.95fr 0.9fr;
    align-items: center;
    gap: clamp(22px, 4vw, 56px);
  }

  .zv3-copy {
    position: relative;
    z-index: 3;
  }

  .zv3-tag {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 15px;
    border-radius: 999px;
    background: rgba(255,255,255,.8);
    border: 1px solid rgba(15,118,110,.12);
    color: var(--zv3-teal);
    font-family: var(--zv3-display);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1.7px;
    text-transform: uppercase;
    box-shadow: 0 16px 40px rgba(15,23,42,.05);
  }

  .zv3-tag-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: var(--zv3-green-2);
    box-shadow: 0 0 0 6px rgba(34,197,94,.14);
  }

  .zv3-title {
    margin: 20px 0 0;
    color: #071b18;
    font-family: var(--zv3-display);
    font-size: clamp(36px, 4.4vw, 62px);
    line-height: .94;
    letter-spacing: -.065em;
    font-weight: 800;
    max-width: 660px;
  }

  .zv3-title span {
    display: block;
    margin-top: 12px;
    background: linear-gradient(135deg, #075E54, #118a4f, #25D366);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .zv3-sub {
    max-width: 500px;
    margin: 18px 0 0;
    color: var(--zv3-soft-ink);
    font-family: var(--zv3-body);
    font-size: clamp(16px, 1.5vw, 19px);
    line-height: 1.78;
    font-weight: 500;
    letter-spacing: -.012em;
  }

  .zv3-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0,1fr));
    gap: 12px;
    max-width: 500px;
    margin-top: 22px;
  }

  .zv3-metric-card {
    padding: 15px;
    border-radius: 24px;
    background: rgba(255,255,255,.84);
    border: 1px solid rgba(15,23,42,.08);
    box-shadow: 0 20px 48px rgba(15,23,42,.06);
    backdrop-filter: blur(10px);
  }

  .zv3-metric-label {
    color: var(--zv3-muted);
    font-family: var(--zv3-display);
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .12em;
  }

  .zv3-metric-value {
    margin-top: 8px;
    color: var(--zv3-ink);
    font-family: var(--zv3-body);
    font-size: 17px;
    line-height: 1.35;
    font-weight: 900;
    letter-spacing: -.02em;
  }

  .zv3-device-stage {
    position: relative;
    min-height: 620px;
    display: grid;
    place-items: center;
    perspective: 1600px;
  }

  .zv3-device-shadow {
    position: absolute;
    width: 320px;
    height: 76px;
    bottom: 16px;
    border-radius: 50%;
    background: radial-gradient(ellipse, rgba(15,23,42,.22), transparent 68%);
    filter: blur(18px);
    animation: zv3ShadowPulse 5s ease-in-out infinite;
  }

  .zv3-phone {
    position: relative;
    width: clamp(292px, 30vw, 330px);
    height: clamp(584px, 60vw, 660px);
    transform-style: preserve-3d;
    animation: zv3DeviceFloat 5.4s ease-in-out infinite;
  }

  .zv3-phone-glow {
    position: absolute;
    inset: -16px;
    border-radius: 62px;
    background: linear-gradient(135deg,
      rgba(34,197,94,.22),
      rgba(15,118,110,.08),
      rgba(37,211,102,.14)
    );
    filter: blur(18px);
  }

  .zv3-phone-frame {
    position: absolute;
    inset: 0;
    padding: 11px;
    border-radius: 48px;
    background:
      linear-gradient(145deg, #030712 0%, #0f172a 48%, #111827 100%);
    box-shadow:
      inset 0 0 0 2px rgba(255,255,255,.08),
      inset 0 -18px 34px rgba(0,0,0,.35),
      0 42px 120px rgba(15,23,42,.24);
  }

  .zv3-notch {
    position: absolute;
    z-index: 30;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: 98px;
    height: 23px;
    border-radius: 0 0 18px 18px;
    background: #020617;
  }

  .zv3-screen {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 38px;
    background: #ffffff;
  }

  .zv3-status-bar {
    position: absolute;
    z-index: 40;
    left: 0;
    right: 0;
    top: 0;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 26px;
    color: rgba(15,23,42,.9);
    font-family: var(--zv3-whatsapp);
    font-size: 13px;
    font-weight: 800;
    letter-spacing: -.01em;
  }

  .zv3-status-right {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .zv3-signal {
    width: 16px;
    height: 11px;
    display: inline-block;
    background:
      linear-gradient(to top, #0f172a 0 3px, transparent 3px),
      linear-gradient(to top, #0f172a 0 6px, transparent 6px),
      linear-gradient(to top, #0f172a 0 9px, transparent 9px);
    background-size: 4px 11px, 4px 11px, 4px 11px;
    background-position: 0 bottom, 6px bottom, 12px bottom;
    background-repeat: no-repeat;
    opacity: .85;
  }

  .zv3-wifi {
    width: 15px;
    height: 11px;
    border: 2px solid #0f172a;
    border-bottom: 0;
    border-left-color: transparent;
    border-right-color: transparent;
    border-radius: 12px 12px 0 0;
    opacity: .85;
  }

  .zv3-battery {
    position: relative;
    width: 22px;
    height: 11px;
    border: 2px solid rgba(15,23,42,.88);
    border-radius: 4px;
  }

  .zv3-battery::after {
    content: "";
    position: absolute;
    right: -5px;
    top: 2px;
    width: 3px;
    height: 5px;
    border-radius: 2px;
    background: rgba(15,23,42,.88);
  }

  .zv3-battery-level {
    position: absolute;
    left: 2px;
    top: 2px;
    width: 13px;
    height: 3px;
    border-radius: 2px;
    background: var(--zv3-green);
  }

  .zv3-scene {
    position: absolute;
    inset: 0;
    padding-top: 46px;
    opacity: 0;
    transform: scale(1.02);
    pointer-events: none;
  }

  .zv3-scene-search {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-inline: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    animation: zv3SceneSearch var(--zv3-duration) linear infinite;
  }

  .zv3-google-logo {
    margin-top: 125px;
    display: flex;
    align-items: center;
    font-family: var(--zv3-google);
    font-size: 50px;
    line-height: 1;
    letter-spacing: -.08em;
    font-weight: 700;
    animation: zv3SearchLogoIn var(--zv3-duration) linear infinite;
  }

  .g-deep { color: #075E54; }
  .g-leaf { color: #118a4f; }
  .g-bright { color: #25D366; }
  .g-fresh { color: #25D366; }

  .zv3-search-bar {
    width: 100%;
    margin-top: 28px;
    height: 56px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 18px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 18px 42px rgba(15,23,42,.08);
    font-family: var(--zv3-body);
  }

  .zv3-search-icon {
    width: 19px;
    height: 19px;
    color: #64748b;
    flex: 0 0 auto;
  }

  .zv3-search-text-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .zv3-search-text {
    max-width: 0;
    white-space: nowrap;
    overflow: hidden;
    color: #111827;
    font-family: var(--zv3-body);
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -.01em;
    animation: zv3TypeSearch var(--zv3-duration) steps(27) infinite;
  }

  .zv3-search-cursor {
    width: 2px;
    height: 20px;
    margin-left: 2px;
    background: #111827;
    border-radius: 1px;
    animation:
      zv3CursorBlink .8s steps(1) infinite,
      zv3CursorHide var(--zv3-duration) linear infinite;
  }

  .zv3-search-actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zv3-mic-dot {
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: linear-gradient(135deg, #ef4444, #f59e0b, #22c55e, #3b82f6);
  }

  .zv3-search-helper {
    margin-top: 16px;
    color: #64748b;
    font-family: var(--zv3-body);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -.01em;
  }

  .zv3-scene-results {
    padding: 54px 16px 14px;
    background: #ffffff;
    animation: zv3SceneResults var(--zv3-duration) linear infinite;
  }

  .zv3-results-top {
    display: flex;
    align-items: center;
  }

  .zv3-results-search {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-radius: 999px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 20px rgba(15,23,42,.04);
  }

  .zv3-results-query {
    color: #111827;
    font-family: var(--zv3-body);
    font-size: 12px;
    font-weight: 800;
    letter-spacing: -.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .zv3-results-tabs {
    display: flex;
    gap: 18px;
    margin-top: 18px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f7;
    color: #64748b;
    font-family: var(--zv3-body);
    font-size: 12px;
    font-weight: 800;
    letter-spacing: -.01em;
  }

  .zv3-results-tabs .active {
    color: #075E54;
    position: relative;
  }

  .zv3-results-tabs .active::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -13px;
    height: 2px;
    background: #25D366;
    border-radius: 999px;
  }

  .zv3-result-card {
    margin-top: 13px;
    padding: 13px;
    border-radius: 22px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 14px 28px rgba(15,23,42,.05);
    opacity: 0;
    transform: translateY(18px);
    animation: zv3ResultCardIn var(--zv3-duration) linear infinite;
  }

  .zv3-result-card.r2 { animation-delay: .18s; }
  .zv3-result-card.r3 { animation-delay: .36s; }

  .zv3-result-card small {
    display: block;
    color: #64748b;
    font-family: var(--zv3-display);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
  }

  .zv3-result-card h4 {
    margin: 7px 0 0;
    color: #1d4ed8;
    font-family: var(--zv3-display);
    font-size: 13.5px;
    line-height: 1.28;
    font-weight: 700;
    letter-spacing: -.035em;
  }

  .zv3-result-card p {
    margin: 7px 0 0;
    color: #475569;
    font-family: var(--zv3-body);
    font-size: 11px;
    line-height: 1.55;
    font-weight: 600;
    letter-spacing: -.01em;
  }

  .zv3-result-card.warning {
    background: #fff7ed;
    border-color: #fed7aa;
  }

  .zv3-result-card.warning h4 {
    color: #c2410c;
  }

  .zv3-result-card.warning p {
    color: #7c2d12;
  }

  .zv3-scene-contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 58px 18px 18px;
    text-align: center;
    background:
      radial-gradient(circle at 50% 26%, rgba(34,197,94,.22), transparent 36%),
      linear-gradient(180deg, #ecfdf5 0%, #ffffff 76%);
    animation: zv3SceneContact var(--zv3-duration) linear infinite;
  }

  .zv3-contact-hero {
    animation: zv3ContactPop var(--zv3-duration) linear infinite;
  }

  .zv3-contact-logo-wrap {
    width: 88px;
    height: 88px;
    margin: 0 auto;
    border-radius: 30px;
    background: rgba(255,255,255,.9);
    display: grid;
    place-items: center;
    box-shadow: 0 28px 70px rgba(15,23,42,.12);
    overflow: hidden;
  }

  .zv3-contact-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .zv3-contact-brand {
    margin-top: 16px;
    color: #052e2b;
    font-family: var(--zv3-display);
    font-size: 31px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: -.06em;
  }

  .zv3-contact-desc {
    margin-top: 10px;
    color: #475569;
    font-family: var(--zv3-body);
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -.01em;
  }

  .zv3-contact-number-card {
    width: 100%;
    margin-top: 20px;
    padding: 18px;
    border-radius: 26px;
    background: rgba(255,255,255,.9);
    border: 1px solid rgba(22,163,74,.18);
    box-shadow: 0 22px 58px rgba(15,23,42,.08);
    animation: zv3ContactCardPulse var(--zv3-duration) linear infinite;
  }

  .zv3-contact-number-label {
    color: #15803d;
    font-family: var(--zv3-display);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: .14em;
    text-transform: uppercase;
  }

  .zv3-contact-number {
    margin-top: 8px;
    color: #052e2b;
    font-family: var(--zv3-display);
    font-size: 27px;
    font-weight: 800;
    line-height: 1.1;
    letter-spacing: -.04em;
    font-variant-numeric: tabular-nums;
  }

  .zv3-contact-number-sub {
    margin-top: 8px;
    color: #64748b;
    font-family: var(--zv3-body);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: -.01em;
  }

  .zv3-contact-pills {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 9px;
    margin-top: 24px;
  }

  .zv3-contact-pills span {
    padding: 9px 12px;
    border-radius: 999px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    color: #166534;
    font-family: var(--zv3-display);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .01em;
  }

  .zv3-scene-whatsapp {
    background: #efeae2;
    animation: zv3SceneWhatsapp var(--zv3-duration) linear infinite;
  }

  .zv3-wa-wallpaper {
    position: absolute;
    inset: 0;
    background-color: #efeae2;
    background-image:
      radial-gradient(circle at 12px 12px, rgba(15,118,110,.07) 1px, transparent 1px),
      radial-gradient(circle at 30px 26px, rgba(15,118,110,.05) 1px, transparent 1px);
    background-size: 42px 42px;
  }

  .zv3-wa-header {
    position: absolute;
    z-index: 5;
    left: 0;
    right: 0;
    top: 40px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #075e54;
    color: #ffffff;
    box-shadow: 0 4px 18px rgba(15,23,42,.14);
    font-family: var(--zv3-whatsapp);
  }

  .zv3-wa-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .zv3-wa-back {
    font-size: 31px;
    line-height: 1;
    margin-top: -2px;
    opacity: .94;
    font-family: var(--zv3-whatsapp);
    font-weight: 400;
  }

  .zv3-wa-avatar {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    overflow: hidden;
    background: #ffffff;
    flex: 0 0 auto;
    box-shadow: inset 0 0 0 2px rgba(255,255,255,.12);
  }

  .zv3-wa-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .zv3-wa-profile {
    min-width: 0;
  }

  .zv3-wa-profile strong {
    display: block;
    font-family: var(--zv3-whatsapp);
    font-size: 16px;
    line-height: 1.15;
    font-weight: 800;
    letter-spacing: -.015em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .zv3-wa-profile span {
    display: block;
    margin-top: 4px;
    color: rgba(255,255,255,.76);
    font-family: var(--zv3-whatsapp);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.01em;
  }

  .zv3-wa-header-right {
    display: flex;
    align-items: center;
    gap: 14px;
    font-family: var(--zv3-whatsapp);
    font-size: 20px;
    font-weight: 700;
  }

  .zv3-wa-date-chip {
    position: absolute;
    z-index: 4;
    top: 112px;
    left: 50%;
    transform: translateX(-50%);
    padding: 6px 12px;
    border-radius: 10px;
    background: rgba(255,255,255,.78);
    color: #64748b;
    font-family: var(--zv3-whatsapp);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: -.01em;
    box-shadow: 0 10px 24px rgba(15,23,42,.08);
  }

  .zv3-wa-messages {
    position: absolute;
    inset: 102px 0 64px;
    padding: 36px 10px 10px;
    overflow: hidden;
  }

  .zv3-wa-row {
    width: 100%;
    display: flex;
    margin: 8px 0;
    opacity: 0;
    transform: translateY(16px) scale(.96);
  }

  .zv3-wa-row.left { justify-content: flex-start; }
  .zv3-wa-row.right { justify-content: flex-end; }

  .zv3-wa-bubble {
    position: relative;
    max-width: 78%;
    padding: 8px 10px 15px;
    border-radius: 16px;
    font-family: var(--zv3-whatsapp);
    font-size: 11px;
    line-height: 1.5;
    font-weight: 600;
    letter-spacing: -.006em;
    color: #111827;
    box-shadow: 0 3px 12px rgba(15,23,42,.06);
  }

  .zv3-wa-row.right .zv3-wa-bubble {
    background: #dcf8c6;
    border-top-right-radius: 6px;
  }

  .zv3-wa-row.left .zv3-wa-bubble {
    background: #ffffff;
    border-top-left-radius: 6px;
  }

  .zv3-wa-bubble small {
    position: absolute;
    right: 10px;
    bottom: 3px;
    color: rgba(15,23,42,.45);
    font-family: var(--zv3-whatsapp);
    font-size: 9px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  .zv3-wa-typing {
    min-width: 74px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0 12px;
  }

  .zv3-wa-typing i {
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: #94a3b8;
    animation: zv3TypingDots 1s ease-in-out infinite;
  }

  .zv3-wa-typing i:nth-child(2) { animation-delay: .14s; }
  .zv3-wa-typing i:nth-child(3) { animation-delay: .28s; }

  .zv3-wa-compose {
    position: absolute;
    z-index: 6;
    left: 0;
    right: 0;
    bottom: 0;
    height: 64px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 10px 14px;
    background: rgba(239,234,226,.95);
    font-family: var(--zv3-whatsapp);
  }

  .zv3-wa-compose-left {
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background: rgba(255,255,255,.86);
    color: #64748b;
    font-family: var(--zv3-whatsapp);
    font-size: 24px;
    font-weight: 400;
  }

  .zv3-wa-input {
    flex: 1;
    height: 38px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-radius: 999px;
    background: #ffffff;
    color: #94a3b8;
    font-family: var(--zv3-whatsapp);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -.01em;
  }

  .zv3-wa-send {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background: #25d366;
    color: #ffffff;
    box-shadow: 0 10px 24px rgba(37,211,102,.28);
  }

  .zv3-wa-send svg {
    width: 20px;
    height: 20px;
    transform: translateX(1px);
  }

  .m1 { animation: zv3Bubble1 var(--zv3-duration) linear infinite; }
  .t1 { animation: zv3Typing1 var(--zv3-duration) linear infinite; }
  .m2 { animation: zv3Bubble2 var(--zv3-duration) linear infinite; }
  .m3 { animation: zv3Bubble3 var(--zv3-duration) linear infinite; }
  .t2 { animation: zv3Typing2 var(--zv3-duration) linear infinite; }
  .m4 { animation: zv3Bubble4 var(--zv3-duration) linear infinite; }
  .m5 { animation: zv3Bubble5 var(--zv3-duration) linear infinite; }
  .m6 { animation: zv3Bubble6 var(--zv3-duration) linear infinite; }

  .zv3-scene-final {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-inline: 28px;
    text-align: center;
    overflow: hidden;
    background:
      radial-gradient(circle at 50% 36%, rgba(34,197,94,.26), transparent 38%),
      linear-gradient(135deg, #052e2b, #064e3b 54%, #0f766e);
    color: #ffffff;
    animation: zv3SceneFinal var(--zv3-duration) linear infinite;
  }

  .zv3-final-rings {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
  }

  .zv3-final-rings span {
    position: absolute;
    width: 190px;
    height: 190px;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,.28);
    opacity: 0;
    animation: zv3FinalRing var(--zv3-duration) linear infinite;
  }

  .zv3-final-rings span:nth-child(2) { animation-delay: .6s; }
  .zv3-final-rings span:nth-child(3) { animation-delay: 1.2s; }

  .zv3-final-logo-wrap {
    position: relative;
    z-index: 3;
    width: 88px;
    height: 88px;
    border-radius: 28px;
    overflow: hidden;
    background: rgba(255,255,255,.12);
    border: 1px solid rgba(255,255,255,.24);
    backdrop-filter: blur(14px);
    box-shadow: 0 28px 80px rgba(0,0,0,.2);
    animation: zv3FinalLogoIn var(--zv3-duration) linear infinite;
  }

  .zv3-final-logo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .zv3-final-title {
    position: relative;
    z-index: 3;
    margin: 20px 0 0;
    font-family: var(--zv3-display);
    font-size: 36px;
    line-height: .96;
    font-weight: 800;
    letter-spacing: -.07em;
  }

  .zv3-final-title span {
    display: block;
    margin-top: 8px;
    color: #bbf7d0;
  }

  .zv3-final-sub {
    position: relative;
    z-index: 3;
    margin: 18px 0 0;
    max-width: 320px;
    color: rgba(255,255,255,.82);
    font-family: var(--zv3-body);
    font-size: 15px;
    line-height: 1.55;
    font-weight: 600;
    letter-spacing: -.01em;
  }

  .zv3-final-number {
    position: relative;
    z-index: 3;
    margin-top: 24px;
    padding: 14px 18px;
    border-radius: 999px;
    background: #ffffff;
    color: #064e3b;
    font-family: var(--zv3-display);
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -.025em;
    font-variant-numeric: tabular-nums;
    box-shadow: 0 18px 40px rgba(0,0,0,.18);
  }

  @keyframes zv3SceneSearch {
    0%, 24% { opacity: 1; transform: scale(1); }
    28%, 100% { opacity: 0; transform: scale(1.02); }
  }

  @keyframes zv3SceneResults {
    0%, 24% { opacity: 0; transform: translateX(22px); }
    27%, 46% { opacity: 1; transform: translateX(0); }
    50%, 100% { opacity: 0; transform: translateX(-16px); }
  }

  @keyframes zv3SceneContact {
    0%, 47% { opacity: 0; transform: scale(1.03); }
    50%, 62% { opacity: 1; transform: scale(1); }
    66%, 100% { opacity: 0; transform: scale(.98); }
  }

  @keyframes zv3SceneWhatsapp {
    0%, 63% { opacity: 0; transform: translateY(16px) scale(1.02); }
    67%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    91%, 100% { opacity: 0; transform: translateY(-10px) scale(1.01); }
  }

  @keyframes zv3SceneFinal {
    0%, 89% { opacity: 0; transform: scale(1.04); }
    92%, 99% { opacity: 1; transform: scale(1); }
    100% { opacity: 0; transform: scale(1.02); }
  }

  @keyframes zv3SearchLogoIn {
    0%, 5% { opacity: 0; transform: translateY(20px) scale(.96); }
    8%, 24% { opacity: 1; transform: translateY(0) scale(1); }
    28%, 100% { opacity: 0; transform: translateY(-10px); }
  }

  @keyframes zv3TypeSearch {
    0%, 8% { max-width: 0; }
    18%, 24% { max-width: 255px; }
    28%, 100% { max-width: 255px; }
  }

  @keyframes zv3CursorBlink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0; }
  }

  @keyframes zv3CursorHide {
    0%, 23% { opacity: 1; }
    24%, 100% { opacity: 0; }
  }

  @keyframes zv3ResultCardIn {
    0%, 28% { opacity: 0; transform: translateY(18px); }
    32%, 46% { opacity: 1; transform: translateY(0); }
    50%, 100% { opacity: 0; transform: translateY(-10px); }
  }

  @keyframes zv3ContactPop {
    0%, 49% { opacity: 0; transform: scale(.65) translateY(16px); }
    53%, 62% { opacity: 1; transform: scale(1) translateY(0); }
    66%, 100% { opacity: 0; transform: scale(.96) translateY(-10px); }
  }

  @keyframes zv3ContactCardPulse {
    0%, 51% { opacity: 0; transform: translateY(10px) scale(.98); }
    55%, 62% {
      opacity: 1;
      transform: translateY(0) scale(1);
      box-shadow: 0 22px 58px rgba(15,23,42,.08), 0 0 0 8px rgba(34,197,94,.12);
    }
    66%, 100% { opacity: 0; transform: translateY(-8px) scale(.98); }
  }

  @keyframes zv3Bubble1 {
    0%, 68% { opacity: 0; transform: translateY(16px) scale(.96); }
    70%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3Typing1 {
    0%, 71% { opacity: 0; transform: translateY(16px) scale(.96); }
    72%, 74% { opacity: 1; transform: translateY(0) scale(1); }
    75%, 100% { opacity: 0; }
  }

  @keyframes zv3Bubble2 {
    0%, 74% { opacity: 0; transform: translateY(16px) scale(.96); }
    76%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3Bubble3 {
    0%, 77% { opacity: 0; transform: translateY(16px) scale(.96); }
    79%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3Typing2 {
    0%, 80% { opacity: 0; transform: translateY(16px) scale(.96); }
    81%, 83% { opacity: 1; transform: translateY(0) scale(1); }
    84%, 100% { opacity: 0; }
  }

  @keyframes zv3Bubble4 {
    0%, 82% { opacity: 0; transform: translateY(16px) scale(.96); }
    84%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3Bubble5 {
    0%, 85% { opacity: 0; transform: translateY(16px) scale(.96); }
    86%, 88% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3Bubble6 {
    0%, 86.5% { opacity: 0; transform: translateY(16px) scale(.96); }
    88%, 90% { opacity: 1; transform: translateY(0) scale(1); }
    92%, 100% { opacity: 0; }
  }

  @keyframes zv3TypingDots {
    0%, 80%, 100% { transform: translateY(0); opacity: .42; }
    40% { transform: translateY(-4px); opacity: 1; }
  }

  @keyframes zv3FinalRing {
    0%, 90% { opacity: 0; transform: scale(.4); }
    92% { opacity: .55; transform: scale(.65); }
    99%, 100% { opacity: 0; transform: scale(2.3); }
  }

  @keyframes zv3FinalLogoIn {
    0%, 90% { opacity: 0; transform: translateY(20px) scale(.75) rotate(-6deg); }
    93%, 99% { opacity: 1; transform: translateY(0) scale(1) rotate(0); }
    100% { opacity: 0; transform: translateY(-10px) scale(.95); }
  }

  @keyframes zv3AmbientFloat {
    0%, 100% { transform: translate3d(0,0,0) scale(1); }
    50% { transform: translate3d(14px,-18px,0) scale(1.06); }
  }

  @keyframes zv3ShadowPulse {
    0%, 100% { transform: scaleX(.94); opacity: .62; }
    50% { transform: scaleX(1.05); opacity: .82; }
  }

  @keyframes zv3DeviceFloat {
    0%, 100% { transform: rotateX(0deg) rotateY(-6deg) translateY(0); }
    50% { transform: rotateX(1deg) rotateY(-3deg) translateY(-12px); }
  }

  @media (max-width: 980px) {
    .zv3-wrap {
      min-height: 100svh;
      padding: 18px 16px 28px;
    }

    .zv3-layout {
      grid-template-columns: 1fr;
      gap: 36px;
    }

    .zv3-copy {
      text-align: center;
    }

    .zv3-tag,
    .zv3-sub,
    .zv3-metrics {
      margin-left: auto;
      margin-right: auto;
    }

    .zv3-title {
      margin-left: auto;
      margin-right: auto;
    }

    .zv3-device-stage {
      min-height: 620px;
    }
  }

  @media (max-width: 520px) {
    .zv3-phone {
      width: min(312px, 88vw);
      height: min(624px, calc(88vw * 2));
    }

    .zv3-phone-frame {
      border-radius: 48px;
      padding: 11px;
    }

    .zv3-screen {
      border-radius: 38px;
    }

    .zv3-metrics {
      grid-template-columns: 1fr;
    }

    .zv3-title {
      font-size: 36px;
    }

    .zv3-final-title {
      font-size: 38px;
    }

    .zv3-contact-number {
      font-size: 28px;
    }
  }
`;
